<template>
    <p class="buttons">
        <router-link class="btn btn_action btn_add" :title="title" :to="{ name: this.routeName }">
            {{ this.title }}
        </router-link>
    </p>
</template>

<script>
	export default {
		name: "add-button",
		props: {
			title: String,
			routeName: String
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/AddButton.vue